import { render, staticRenderFns } from "./AssistantDrawer.vue?vue&type=template&id=6b63fce6&scoped=true"
import script from "./AssistantDrawer.vue?vue&type=script&lang=js"
export * from "./AssistantDrawer.vue?vue&type=script&lang=js"
import style0 from "./AssistantDrawer.vue?vue&type=style&index=0&id=6b63fce6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b63fce6",
  null
  
)

export default component.exports